import React from 'react';
import "./css/colabora.css";
import { Link } from 'react-router-dom';

import donar from "./assets/donar/Screenshot 2025-09-01 202704.png";

export default function Colabora() {
    const planes = [
        {categoria: "Oro", precio: "500€ + IVA", caracteristicas: ["Logo de la empresa en comunicaciones de la Olimpiada y en la página web"]},
        {categoria: "Platino", precio: "1500€ + IVA", caracteristicas: ["Logo de la empresa en comunicaciones de la Olimpiada y en la página web", "Conferencia en la gala final de cinco minutos", "Un objeto en la final de merchandising (ejemplo: cascos o libreta)", "Contacto con las medallistas de cara a futuros contratos"]},
        {categoria: "Diamante", precio: "2500€ + IVA", caracteristicas: ["Logo de la empresa en comunicaciones de la Olimpiada y en la página web", "Conferencia en la gala final de diez minutos", "Un pack en la final de merchandising (ejemplo: mochila con productos de la empresa)", "Contacto con las medallistas de cara a futuros contratos", "Apartado en oifem.es sobre su empresa"]}
    ];


    return (
        <div id="colabora">
            <div className='destacado'>
                <h1>Planes para empresas</h1>
                <p>
                    La OIFem se mantiene gracias a los patrocinios de numerosas empresas y la colaboración de importantes instituciones. 
                    Debajo de esta página podrás encontrar las que están ayudando a que la segunda edición sea posible.
                </p>

                <p>
                    A continuación les mostramos los tres planes para empresas que se firman anualmente. Si te interesa colaborar, manda un email a través de nuestro
                    {' '}<Link to="/contacto">formulario de contacto</Link>
                </p>

                <div className='planes'>
                    {planes.map((plan, index) => (
                        <div className='plan' key={index}>
                            <h3>{plan.categoria}</h3>
                            <h3>{plan.precio}</h3>

                            {plan.caracteristicas.map((caracteristica, i) => (
                                <p key={i}>{caracteristica}</p>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            <div>
                <h1>Colabora de forma individual</h1>
                <p>
                    Estamos en búsqueda continua de voluntarios para tareas técnicas y eventos en persona, por lo que si estás interesado en colaborar, puedes rellenar el siguiente
                    {' '}<a href="https://docs.google.com/forms/d/e/1FAIpQLScF40guCDeru0VPJOi1ICI9OUJBmC99Th0sxWZQl1nd8adldQ/viewform" target="_blank" rel="noopener noreferrer">formulario.</a>
                </p>

                <p>
                    Además, tenemos abierta una opción para donar a la OIFem a título personal, a través del siguiente botón. ¡Muchas gracias de antemano! Con vuestra ayuda, lograremos que la programación 
                    llegue a todavía más alumnas y que España pueda ser un referente internacional en esta materia.
                </p>

                <p>
                    Ten en cuenta que nosotros, salvo que nos lo indiques a través de la nota que te permite enviarnos PayPal, no sabremos quién eres, así que nos encantaría que pusieras tu nombre y/o 
                    correo cuando te aparezca la opción de nota para poder agradecértelo personalmente.
                </p>

                <div id="donar-holder">
                    <form action="https://www.paypal.com/donate" method="post" target="_top">
                    <div>
                        <input type="hidden" name="hosted_button_id" value="2E5DGN7QYA874" />
                        {/* <input type="hidden" name="return" value="https://oifem.es/gracias.html"> */}
                        <input type="image" src={donar} border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                        <img border="0" src="https://www.paypal.com/en_ES/i/scr/pixel.gif" width="1" height="1"/>
                    </div>
                </form>
                </div>
            </div>

            <div>
                <h1>Colabora desde una asociación sin ánimo de lucro o una AAPP</h1>
                <p>Contáctanos a través del formulario de contacto, ya que estas colaboraciones son diferentes para cada caso.</p>
            </div>
        </div>
    );
}